import { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

import { Capacitor } from '@capacitor/core';

import router from '@/router';
import { PARTNER_TYPE_MAP } from '@/utils/constants/common';
import { isInCapacitorApp } from '@/utils/device';
import { navigateInApp } from '@/utils/native/nativeBridge';

/**
 * @desc 로그인 페이지로 이동하는 로직입니다.
 * @param afterLoginPath - 로그인 이후 이동할 path. 미지정 시 현재 전체 경로 유지.
 */
export default function redirectToLoginPage(afterLoginPath?: string, partnerType?: string) {
  if (isInCapacitorApp()) {
    goToMobileLoginPage();
    return;
  }

  const route = router.currentRoute.value;
  const { domain } = route.meta;

  const isSelfService = domain === 'SELF_SERVICE' || partnerType === 'SELF_SERVICE';

  return router.replace(
    isSelfService
      ? getSelfServiceRedirectUrl(route, afterLoginPath)
      : getRedirectUrl(route, afterLoginPath, partnerType)
  );
}

const getRedirectUrl = (route: RouteLocationNormalizedLoadedGeneric, afterLoginPath: string, partnerType?: string) => {
  const params = new URLSearchParams();
  const { pathname, search } = window.location;
  const { chatType } = route.meta;

  if (partnerType && PARTNER_TYPE_MAP[partnerType]) {
    params.set('type', PARTNER_TYPE_MAP[partnerType]);
  }

  const redirectPath = afterLoginPath || `${pathname}${search}`;
  params.set('redirectTo', redirectPath);

  // 02) 싱글모드/청취모드일경우, partnerCode를 셋팅합니다.
  const partnerCode = route.params.partnerCode as string;
  if (['SINGLE', 'AUDIENCE'].includes(chatType) && partnerCode) {
    params.set('partnerCode', partnerCode);
    params.set('redirectTo', route.path.split('/').slice(0, 3).join('/'));
  }

  return `/login?${decodeURIComponent(params)}`;
};

const getSelfServiceRedirectUrl = (route: RouteLocationNormalizedLoadedGeneric, afterLoginPath: string) => {
  const params = new URLSearchParams();

  const { pathname, search } = window.location;

  const redirectPath = afterLoginPath || `${pathname}${search}`;
  params.set('redirectTo', redirectPath);

  if (!redirectPath.includes('partnerCode')) {
    const partnerCode = localStorage.getItem('partner-code-admin');
    if (partnerCode) {
      params.set('partnerCode', partnerCode);
    }
  }

  return `/login/ss?${decodeURIComponent(params)}`;
};

export const getQueryString = (query: Record<string, any>) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => params.append(key, String(value)));
  return params.toString().replace(/%2F/g, '/');
};

export const goToMobileLoginPage = () => {
  const domain = Capacitor.getPlatform() === 'ios' ? 'capacitor://localhost/' : 'https://localhost/';

  navigateInApp(`${domain}app/login`);
};
